import { ArrowForward, InfoOutlined } from '@mui/icons-material'
import { Alert, Box, Container, Stack, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { ContainedButton } from '../../../components/Button'
import { CustomTextField } from '../../../components/CustomTextField'
import { AppDispatch } from '../../../store'
import { VerificationActions, VerificationSelector } from '../../../store/Verification'
import { useSnackbar } from '../../../hooks/snackbar/useSnackbar'

export const VerifyEmail = () => {
  const [emailError, setEmailError] = useState('')
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { showSuccess, showError } = useSnackbar()

  const { requestLoading, inputEmail: email } = useSelector(VerificationSelector.getVerificationState)

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value
    dispatch(VerificationActions.setInputEmail(newEmail))
  }

  const handleSubmit = async () => {
    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address')
      return
    }
    const resultAction: any = await dispatch(VerificationActions.sendOtpAsync(email))
    if (VerificationActions.sendOtpAsync.fulfilled.match(resultAction)) {
      if (resultAction.payload.success) {
        showSuccess(resultAction.payload.message)
        navigate('/test-strip/verify-otp')
      }
    } else {
      showError(resultAction.payload.error)
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        minHeight: 'calc(100vh - 68px)',
        py: 3,
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Stack alignItems="center" spacing={3.5} sx={{ maxWidth: '450px' }}>
            <Stack alignItems="center">
              <Typography
                fontSize={{xs: "2rem", md:'2.2rem'}}
                fontWeight={theme.typography.fontWeightBold}
                color='text.primary'
                textAlign={'center'}
              >
                Let's get started!
              </Typography>

              <Typography fontSize={'1rem'} color={theme.palette.grey[600]}>
                Let's verify your email to get your test results
              </Typography>
            </Stack>

            <Alert severity="blue" icon={<InfoOutlined />} variant="filled">
              {' '}
              Use the same email address you provided when ordering your test kit
            </Alert>
            <CustomTextField
              label="Your email address"
              name="email"
              value={email}
              onChange={handleEmailChange}
              fullWidth
              placeholder="john.doe@gmail.com"
              required
              error={!!emailError}
              helperText={emailError}
            />

            <ContainedButton
              fullWidth
              size="large"
              sx={{ py: 2 }}
              endIcon={<ArrowForward />}
              onClick={handleSubmit}
              disabled={!email || requestLoading}
            >
              {requestLoading ? 'Sending...' : 'Send Verification code'}
            </ContainedButton>
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}
